"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = inverse;
function inverse(value) {
  return !value;
}